import api from "../../../../api";

export const addEmployeeFormCustomFields = [
    {
        name: "first_name",
        type: "text",
        placeholder: "First Name",
        label: "First Name",
        required: true,
    },
    {
        name: "last_name",
        type: "text",
        placeholder: "Last Name",
        label: "Last Name",
        required: true,
    },
    {
        name: "email",
        type: "email",
        placeholder: "E-Mail",
        label: "Email",
        required: true,
    },
]


export const employeeFilterConfig  = [
  {
    type: "text",
    name: "search",
    label: "Search",
    placeholder: "Search Employees",
  },
  {
      type: "select",
      name: "team_name",
      label: "Department",
      options: [],
      isMulti: true,
  },
  {
    type: "select",
    name: "role",
    label: "Role",
    options: [
      { label: "Team Head", value: "Team Head" },
      { label: "Company Head", value: "Company Head" },
      { label: "Team Member", value: "Member" },
    ],
    isMulti: true,
  },
];
